export const layoutConfig = {
  patterns: {
    // [company] 以下の全てのパスにマッチする正規表現
    // /company-name, /company-name/, /company-name/movies, /company-name/albums など
    company: /^\/[^/]+(?:\/.*)?$/,
  },
  routes: {
    blank: ['/signup', '/talentbook_guide'],
    company: ['/preview/companies/'],
    error: ['/error'],
    member: [
      '/categories/',
      '/contents',
      '/members/mypage',
      '/members/bookshelf',
      '/members/follow',
      '/members/history',
      '/members/recommend',
      '/members/role-model-finder',
      '/members/profile',
      '/info',
    ],
    simple: ['/members/additional_info', '/members/group/join'],
    default: [
      '/',
      '/agreement',
      '/group_policy',
      '/categories',
      '/companies',
      '/faq',
      '/feature',
      '/forgot_password',
      '/login',
      '/members/activate',
      '/members/reset-email',
      '/members/reset-password',
      '/members/settings',
      '/oauth-error',
      '/preview/knowhows',
      '/preview/stories',
      '/privacy_inquiry',
      '/recommended_stories',
      '/role-model-finder/',
      '/search',
      '/signup',
      '/test',
    ],
    // 企業記事ページ（stories, knowhows）をDefaultLayoutに指定
    article: [],
  },
  // 静的ルートの第1セグメント（company routes から除外するパス）
  staticRouteSegments: [
    'agreement',
    'group_policy',
    'categories',
    'companies',
    'contents',
    'error',
    'faq',
    'feature',
    'forgot_password',
    'info',
    'members',
    'oauth-error',
    'privacy_inquiry',
    'recommended_stories',
    'role-model-finder',
    'search',
    'signup',
    'talentbook_guide',
    'test',
  ],
} as const
